import { Avatar, Box, TableCell } from '@mui/material';
import { GridCellProps } from '@progress/kendo-react-grid';

import { getInitials } from '~/services/Employee';

import { useAvatarCellStyles } from './avatarCellStyles';

export const AvatarCell = ({ dataItem, rowType }: GridCellProps) => {
  const sxStyles = useAvatarCellStyles();

  if (rowType !== 'data') {
    return null;
  }

  const { firstName, lastName, profilePic } = dataItem;

  return (
    <TableCell sx={sxStyles.dataCell}>
      <Avatar
        alt={firstName && lastName ? getInitials(firstName, lastName) : ''}
        src={profilePic}
      />
      <Box sx={sxStyles.text}>
        {firstName} {lastName}
      </Box>
    </TableCell>
  );
};
